<div class="col-12 col-sm-11 col-md-11 col-lg-9 col-xl-9 col-xxl-9">
    <h1 class="c11n-text-xl-headline c11n-space-stack-6x">{{ grantorContent?.add_user?.frmcSelectAccessLevel?.heading }}</h1>
    <zci-access-level-tile
        [data]="infoOnlyTileData"
        (click)="selectInfoOnlyAndNavigate()">
    >
    </zci-access-level-tile>
    <zci-access-level-tile
        [data]="limitedTileData"
        (click)="selectLimitedAndNavigate()">
    >
    </zci-access-level-tile>
    <zci-access-level-tile
        [data]="fullAuthorityTileData"
        (click)="navigateToForm()">
    >
    </zci-access-level-tile>
</div>



